import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-716064cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-table-filter" }
const _hoisted_2 = { class: "oxd-table-filter-header" }
const _hoisted_3 = { class: "oxd-table-filter-header-title" }
const _hoisted_4 = { class: "oxd-table-filter-header-options" }
const _hoisted_5 = { class: "--toggle" }
const _hoisted_6 = { class: "--export" }
const _hoisted_7 = { class: "--toggle" }
const _hoisted_8 = { class: "oxd-table-filter-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!
  const _component_oxd_icon_button = _resolveComponent("oxd-icon-button")!
  const _component_oxd_divider = _resolveComponent("oxd-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_oxd_text, {
          class: "oxd-table-filter-title",
          tag: "h5"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.filterTitle), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "toggleOptions", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "exportOptions", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_oxd_icon_button, {
            name: _ctx.isActive ? 'caret-up-fill' : 'caret-down-fill',
            onClick: _ctx.toggleFilters
          }, null, 8, ["name", "onClick"])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_oxd_divider, null, null, 512), [
      [_vShow, _ctx.isActive]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.isActive]
    ])
  ]))
}